import * as React from 'react';
import { useTranslation } from "react-i18next";
import { formatCurrency, formatNumber } from "../../../utils/FormatUtils";
import InvoiceSimpleTable, { SimpleColumnDef } from "../../../component/InvoiceSimpleTable";
import { Typography } from "@mui/material";


const InvoiceItems = (props: any) => {

    const { t } = useTranslation('finance', { keyPrefix: 'payable-invoices' });

    const columnDefs: SimpleColumnDef[] = [
        {
            field: 'serviceDescription', headerName: t('preview.tables.items.description'), width: '40%',
            valueFormatter: (data: any) => {
                return {
                    component: () => data.serviceDescription + (data.totalWithholdingTax > 0 ? "*" : "")
                }
            }
        },
        { field: 'serviceItem.id', headerName: t('preview.tables.items.reference'), width: '10%' },
        {
            field: 'quantity', headerName: t('preview.tables.items.quantity'), width: '100px',
            valueFormatter: (data: any) => {
                return {
                    component: () => formatNumber(1)
                }
            }
        },
        { field: 'serviceItem.um', headerName: t('preview.tables.items.unit-measure'), width: '10%' },
        {
            field: 'unitPrice', headerName: t('preview.tables.items.unit-price'), width: '10%', cellStyle: 'right',
            valueFormatter: (data: any) => {
                return {
                    component: () => {
                        return (
                            <Typography align={'right'}>
                                {formatCurrency(data.unitPrice, props.invoice.currency, 0.01)}
                            </Typography>
                        )
                    }
                }
            }
        },
        {
            field: 'totalNetPrice', headerName: t('preview.tables.items.amount'), width: '100px',cellStyle: 'right',
            valueFormatter: (data: any) => {
                return {
                    component: () =>{
                        return (
                            <Typography align={'right'}>
                                {formatCurrency(data.totalNetPrice, props.invoice.currency, 0.01)}
                            </Typography>
                        )
                    }
                }
            }
        },
        { field: 'taxType.value', headerName: t('preview.tables.items.vat'), width: '10%', cellStyle: 'right',
            valueFormatter: (data: any) => {
                return {
                    component: () => {
                        return (
                            <Typography align={'right'}>
                                {data.taxType.value}
                            </Typography>
                        )
                    }
                }
            }
        },
    ];

    return (
            <>
                <InvoiceSimpleTable columnDefs={columnDefs} data={props.invoice.items}/>
            </>
    )
}
export default InvoiceItems;